import { Box, BoxProps } from "@mui/material";
import React from "react";

export const PageListAndReportsContainer = (props: BoxProps) => (
    <Box display="flex" width="100%">
        {props.children}
    </Box>
);
